// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

// Redux actions
import { storeFormData } from "../../../actions/formActions";

// render components
import ReviewContent from "../ReviewContent";
import Thankyou from "../../global/Thankyou";
import Loading from "../../global/Loading/Loading";

class Submit extends React.Component {
  saveFormData(data) { return this.props.storeFormData( data, ((process.env.NODE_ENV === "development") ? process.env.REACT_APP_HOST_URL : window.location.origin) + "/_webservices/heritage/permit/save"); }

  render() {
    const { handleSubmit, pristine, previousPage, submitting, showThankyou, jumpToPage, isLoading, errorMessage, attachments, formData, formName, submitFailed } = this.props;
    
    let submitButtonClass;
    
    if ( formData.isCommonPropertyInvolved && formData.isCommonPropertyInvolved.length === 1 ) {
      submitButtonClass = formData.hasOwnerProvidedConsent && formData.hasOwnerProvidedConsent.length === 1 && formData.hasOwnerCorpManagerProvidedConsent && formData.hasOwnerCorpManagerProvidedConsent.length === 1 && formData.isApplicantStatementAgreed && formData.isApplicantStatementAgreed.length === 1
      ? ""
      : " disabled";
    } else {
      submitButtonClass = formData.hasOwnerProvidedConsent && formData.hasOwnerProvidedConsent.length === 1 && formData.isApplicantStatementAgreed && formData.isApplicantStatementAgreed.length === 1
      ? ""
      : " disabled";
    }

    if (isLoading) {
      return <Loading />
    } else {
      if (showThankyou) {
        return <Thankyou formData={formData} formName={formName} />
      } else {
        return (
          <form id={formName} onSubmit={handleSubmit(this.saveFormData.bind(this))}>
            <div className="review--title">
              <h2>Review & submit</h2>
              <p>Please review your application. Ensure everything has been entered correctly and truthfully.</p>
            </div>
            <ReviewContent formData={formData} formName={formName} jumpToPage={jumpToPage} attachments={attachments} />
            <div className="sq-form-control">
              <button type="button" className="sq-form-page-button previous" onClick={previousPage}>Previous</button>
              <button type="submit" className={"sq-form-page-button submit" + submitButtonClass} disabled={pristine || submitting}>Submit application</button>
            </div>
            {
              submitFailed === true && (<p className="sq-form-error">Error occurred, if this error persists please save and exit your application and contact Heritage Victoria.</p>)
            }
            {Object.keys(errorMessage).length > 0 && 
              alert("Error code: " + errorMessage.code + '\n' + errorMessage.message.reduce(function (a, b) {
                return {message: a.message + '\n' + b.message};
              }).message)
            }
          </form>
        );
      }
    }
  }
}

const mapStateToProps = (state, formName) => {
  return {
    formData: (state.form[formName.form]) ? state.form[formName.form].values : {},
    submitFailed: (state.form[formName.form]) ? state.form[formName.form].submitFailed : false,
    showThankyou: state.service.showThankyou,
    isLoading: state.service.isPending,
    errorMessage: state.service.error,
    attachments: state.service.attachments
  };
};

const mapDispatchToProps = {
  storeFormData
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
});

export default connect(mapStateToProps, mapDispatchToProps)((form)(Submit));